__webpack_require__.p = "/jogjadigdaya/";